import fetch from 'isomorphic-fetch';
import _ from 'lodash';
import {
  SET_LAST_TIME_PING_SERVER,
} from '../components/sessionRefresher/events';
import resolveAuthToken from './sessionFetch';

export const BEARER = 'Bearer';
export const storeLastTimePingServer = () => ({
  type: SET_LAST_TIME_PING_SERVER,
  time: (new Date()).getTime(),
});

/**
 * @param {string} url
 * @param {Object} params
 * @param {boolean} [skipProgramId]
 * @return {Object}
 */
export default store => (url, params, skipProgramId) => {
  const locale = _.get(store.getState().UserDetail.get('userDetail'), 'preferredLanguage', 'en-us');
  const headers = params.headers || {};
  headers['Accept-Language'] = locale.locale;
  const token = resolveAuthToken(store);
  const programId = _.get(store.getState().UserDetail.get('currentActiveProgram'), 'programId', '');
  const platformProgramId = _.get(store.getState().UserDetail.get('currentActiveProgram'), 'platformProgramId', '');
  if (programId && !skipProgramId) {
    headers.programId = programId;
    headers.platformProgramId = platformProgramId;
  }
  if (token) {
    headers.Authorization = `${BEARER} ${token}`;
  } else if (!headers.Authorization) {
    headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    headers.Pragma = 'no-cache';
  }
  return fetch(url, { ...params, headers }).then((res) => {
    if (res.status === 403) {
      window.location.replace(`/sessionExpired?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`);
      return res;
    }
    if (res.status === 501) {
      window.location.replace('/accessDenied');
      return res;
    }
    store.dispatch(storeLastTimePingServer());
    return res;
  });
};
